import React, { Component } from 'react'
import '../css/App.css'
import OfficeResultList from './OfficeResultList'
import { Link } from 'react-router-dom'
import SummaryBox from './SummaryBox'
import FilterOptions from './FilterOptions'
import * as api from '../utils/api'
import {convertDateFormat, numFormat, capitalizeString, setColor} from '../utils/helper'
import bluebg from '../assets/blue-bg.jpg'
import ERHeader from './ERHeader'
import PartyFilter from './PartyFilter'
import FaAngleLeft from 'react-icons/lib/fa/angle-double-left'
import BackLink from './BackLink'
import GenerateBackLink from './GenerateBackLink'
import '@aspnet/signalr/dist/browser/signalr.js'
import { createBrowserHistory } from 'history'
import swal from 'sweetalert2';
import { LiveMessage } from 'react-aria-live';
import ScrollToTop from './ScrollTop'
import FaHome from 'react-icons/lib/fa/home'

export default class PublicElectionResult extends Component {
  state = {
    election: '',
    resultType: '',
    Wards: [],
    Precincts: [],
    lastUpdate: '',
    electionDate:'',
  //  electionYear:'',
    precinctCount: 0,
    totalPrecincts: 0,
    topResult:null,
    leftPart:{
        resData: null
    },
    rightPart:{
      resData: null
    },
    //summaryData: null,
    batchId:'',
    versions:'',
    currentVersion:'',
    resultsId: this.props.location.state ? this.props.location.state.resultsId : this.props.match.params.resultsId,
    // dateId: this.props.location.state ? this.props.location.state.dateId : this.props.match.params.dateId,
    //slug: this.props.location.slug ? this.props.location.state.slug : this.props.match.params.slug,
    parties:'',
    curParty: '',
    electionCode:'',
    filter:'city',
    wardSelected:'',
    precinctSelected: '',
    wardDefault:'',
    precinctDefault:'',
    // isPublished: false,
    ancs: '',
    ancSelected: '',
    ancDefault: '',
    isAuth: true,
    userId:'',
    officeList:'',
    curOffice:'',
    rawResults:'',
    colors:'',
    CsvLink: '',
    ExcelLink: '',
    PdfLink:'',
    XmlLink: '',
    isLive: false,
    a11yMessage:"",
    connection:'',
    isWardPrecinctAvailable: true,
    appendPartyCodeToCandidateName: false,
  }

  announceToScreenReader = (message) => {
    this.setState({a11yMessage:message})
  }

  componentDidMount(){
    //  if(this.props.location.state && this.props.location.state.filter){
    //       this.getInfoFromState(this.props.location.state)
    //       this.announceToScreenReader("You are now at election results page.");
          
    //   }else{
    //       this.getInfo()
    //   }
     this.getInfo()
   
     window.addEventListener('resize', ()=>{
         const {rawResults, curParty} = this.state
          if(rawResults && rawResults.length){
              if(curParty){
                this.filterPartyResult(curParty)
              }else{
                this.reshapeResult(rawResults, rawResults)
              }
          }
      }) 

  }

  componentWillMount() {
      let browserHistory = createBrowserHistory();
      if(this.props.location.state){
        browserHistory.replace({
            pathname:this.props.match.pathname,
            state: {
              resultsId: this.props.location.state.resultsId
            }
        });
       }
  }

  componentDidUpdate(preProp, preState){
   // console.log(preState.isLive, this.state.isLive)
    if(preState.isLive != this.state.isLive) this.changeConnectionStatus()
  }

  changeConnectionStatus = () =>{
    if(this.state.isLive) this.connectToSignalr()
    else this.disconnectSignalr()
  }

  connectToSignalr = () =>{
      let signalR = window.signalR;
      let connection;
      if(!window.connection){
          connection = new signalR.HubConnectionBuilder()
          .withUrl("/updatehub")
          .build();
          window.connection = connection;

          connection.start().then(() => {
              console.log("connected!")
          })
          .catch(err => console.log(err.toString()));

      }else connection = window.connection;

        connection.on('UpdateListner', (id) => {
        // console.log(id)
        if(id){
          // swal("Updated election result available", "Click to see the latest information." ,"info")
          // .then(() => window.location.reload())
          // .catch(() =>  window.location.reload())
             window.location.reload()
          } else {
          swal("Election Result Unavailable", "You will be redirected to the home page." ,"warning")
          .then(() => window.location.href = '/')
          .catch(() => window.location.href = '/');
          }
        })

        connection.on('UpdateLiveStatus', (isLive) => {
            if(isLive){
            //swal("Notice", "The live update just started.","success");
            }else{
            swal("Notice", "The live update has stopped.","info");
            }
            this.setState({ isLive });
        })
        
  }

  disconnectSignalr =() =>{
      // let {connection} = this.state
      if(window.connection){
          window.connection.stop().then(() => {
              console.log("disconnected!")
          })
          .catch(err => console.log(err.toString()));
      }
  }

  getInfo =() => {
    const {resultsId} = this.state
    
     api.getPublicElectionInfo(resultsId)
          .then(res => {
          // console.log(new Date(res.ElectionDate).getFullYear())
            this.setState({
             // electionYear: new Date(res.ElectionDate).getFullYear(),
              electionDate: res.ElectionDate,
              lastUpdate: res.LastUpdated,
              precinctCount: res.PrecinctsCounted,
              totalPrecincts: res.TotalPrecincts,
              election: res.ElectionNameDisplay,
              resultType: res.ElectionResultsTypeName,
              //batchId: res.WardPrecinctBatchId,
              electionCode: res.ElectionCode,
              // isPublished: res.IsPublished,
              CsvLink: res.CsvLink,
              ExcelLink: res.ExcelLink,
              PdfLink: res.PdfLink,
              XmlLink: res.XmlLink,
              isLive: res.IsLive,
              isWardPrecinctAvailable: res.WardPrecinctStatsFlag,
              appendPartyCodeToCandidateName: res.AppendPartyCodeToCandidateName,
            },  this.getAllInfo)
          })
           
      this.getCityWide()
  }

  getAllInfo = () => {
    document.title = `DCBOE ${this.state.election} Election Results`
      const {resultsId, electionCode} = this.state

       if(electionCode == 'P'){
           this.getParties(resultsId)
       }else{
           api.getPublicAncList(resultsId)
          .then(res => {
            if(res.length){
               this.setState({
                ancs: res,
                ancSelected: res[0],
                ancDefault: res[0]
              })
            }
          })

          api.getPublicPartyColors()
          .then(res => {
              // const specialColors = {writein:'#f9b3c7', overvotes:'#7408be', undervotes: '#fc296d'}
              const specialColors = {writein:'#8f8c8d', overvotes:'#8f8c8d', undervotes: '#8f8c8d'}
              let colors = {}
              res.forEach(p => {
                  colors[p.PartyCode] = p.ColorCode
              })
              colors = Object.assign(specialColors, colors)
          
              this.setState({
                  colors: colors
              })
          })
        }
   
      api.getPublicWardPrecinct(resultsId)
        .then(
            res => {res
            console.log("res => ", res)
            res.WardNumberList.sort((a,b) =>(a-b))
            res.PrecinctNumberList.sort((a, b) => (a - b))  
                
            let precinctAddressList = res.PrecinctAddressList && res.PrecinctAddressList.length > 0
                ? res.PrecinctAddressList.map((item) => { return { value: item.Value, label: item.Label } }) : [];
            precinctAddressList.sort((a, b) => (a.value - b.value));
            this.setState({
                Wards: res.WardNumberList,
                Precincts: res.PrecinctNumberList,                
                wardSelected: res.WardNumberList[0],
                wardDefault: res.WardNumberList[0],
                precinctSelected: res.PrecinctNumberList[0],
                precinctDefault: res.PrecinctNumberList[0],
                //Added for PrecinctAddress
                PrecinctAddresses: precinctAddressList,
                precinctAddressSelected: precinctAddressList[0],
                precinctAddressDefault: precinctAddressList[0]
            })
          }
        )
  }

  getResultsByCity = (e) => {
    e.preventDefault();
    if(this.state.filter != 'city'){
       this.setState({
          filter:'city'
      }, this.getCityWide)
    }
  }

  getResultsByWard = (e) => {
    e.preventDefault();
     if(this.state.filter != 'ward'){
      this.setState({
          filter: 'ward',
          wardSelected: this.state.wardDefault
        }, this.getWards)
     }
   }

  getResultsByPrecinct = (e) => {
    e.preventDefault();
     if(this.state.filter != 'precinct'){
      this.setState({
          filter: 'precinct',
          precinctSelected: this.state.precinctDefault
      }, this.getPrecincts)
     }
  }

  getResultsByANC = (e) => {
    e.preventDefault();
      if(this.state.filter != 'anc'){
        this.setState({
            filter: 'anc',
            ancSelected: this.state.ancDefault
        }, this.getANC)
      }
  }


  getResultsByWardNum = (e, wardNumber) => {
    e.preventDefault();
     if(wardNumber != this.state.wardSelected){
        let wardnum = wardNumber ? wardNumber : e.target.value
        this.setState({
            wardSelected: wardnum
        }, this.getWards)
     }
  }


  getResultsByPrecinctNum = (newValue) => {
    // event.preventDefault();
    // this.setState({
    //     precinctSelected: event.target.value
    // }, this.getPrecincts)
    this.setState({
        precinctSelected: newValue,
    }, this.getPrecincts)
  }

  getResultsByANCNum = (event) => {
     event.preventDefault();
      this.setState({
          ancSelected: event.target.value
      }, this.getANC)
  }

  getPartyResults = (e, partyCode) => {
    e.preventDefault();
    this.filterPartyResult(partyCode)
  }

  filterPartyResult = (partyCode) =>{
      const rawResults = this.state.rawResults
      let result = rawResults.filter(office => office.ElectionData[0].PartyCode == partyCode)
      this.setState({
        curParty: partyCode
      }, () => this.reshapeResult(result, rawResults))
  }

  clearPartyFilter = () =>{
    const rawResults = this.state.rawResults
    this.setState({
        curParty: ''
      }, () => this.reshapeResult(rawResults, rawResults))
  }

  getCityWide = () =>{
      const {resultsId, curParty} = this.state

      // update election results
      api.fetchPublicCityWideResults(resultsId)
      .then(res => {
          if(curParty){
             this.setState({
               rawResults: res
             }, ()=> this.filterPartyResult(curParty))
          }else{
             this.reshapeResult(res, res)
          }
      })
     
  }

  getWards = (e) => {
        //e.preventDefault();
        const {resultsId, curParty, wardSelected} = this.state
        
        if( wardSelected){
            // update election results
            api.fetchPublicWardResults(resultsId, wardSelected)
            .then(res => {
                if(curParty){
                  this.setState({
                    rawResults: res
                  }, ()=> this.filterPartyResult(curParty))
                }else{
                  this.reshapeResult(res, res)
                }
            })
        }
  }

  getPrecincts = (e) =>{
    // e.preventDefault();
     const {resultsId, curParty, precinctSelected} = this.state

     if(precinctSelected){
        // update election results
        api.fetchPublicPrecinctResults(resultsId, precinctSelected)
        .then(res => {
            if(curParty){
                this.setState({
                  rawResults: res
                }, ()=> this.filterPartyResult(curParty))
            }else{
              this.reshapeResult(res, res)
            }
          })
        }
    }

    getANC = () =>{
      const {resultsId, ancSelected} = this.state
      
       // update election results
      api.getPublicANC(resultsId, ancSelected)
      .then(res => {
          this.reshapeResult(res, res)
      })
    }

    reshapeResult = (res, rawResults) =>{
      const {curOffice} = this.state
      const windowWidth = window.innerWidth
      let leftPart = res, rightPart=[], topRes= []

      if(windowWidth >= 768){
        let result = curOffice ? res.filter(val => val.ContestNumber != curOffice) : res.filter(val => !val.IsHighlighted)
        topRes = curOffice ? res.filter(val => val.ContestNumber == curOffice) : res.filter(val => val.IsHighlighted)
        let resultLists = this.divideResults(result)
        leftPart = resultLists[0]
        rightPart = resultLists[1]
      }else{
        topRes = curOffice ? res.filter(val => val.ContestNumber == curOffice) : res.filter(val => val.IsHighlighted)
        leftPart = curOffice ? res.filter(val => val.ContestNumber != curOffice) : res.filter(val => !val.IsHighlighted)
      }
   //  console.log(leftPart, rightPart)
      this.setState({
        leftPart:{
          resData: leftPart
        },
        rightPart:{
          resData: rightPart
        },
        topResult: topRes[0],
        curOffice: topRes[0] ? topRes[0].ContestNumber : '',
        rawResults: rawResults
      })
    }


    handleInputChange = (event, callback) => {
       const target = event.target
       const value = target.type === 'checkbox' ? target.checked : target.value
       const name = target.name
       //console.log(name, value)
       if(callback){
          this.setState({
            [name]: value
          }, callback)
       }else{
          this.setState({
            [name]: value
          })
       }
   }
   
   divideResults = (results) => {
       let leftRow =0, rightRow = 0, leftRes = [], rightRes = []

       results.forEach((e) => {
          if(leftRow <= rightRow){
            leftRow += e.ElectionData.length+1
            leftRes.push(e)
          }else{
            rightRow += e.ElectionData.length+1
            rightRes.push(e)
          }
       })
     return [leftRes, rightRes]
   }

  getParties = (resultsId) =>{
     api.getPublicPartiesForPrimary(resultsId)
      .then(res => {
          let colors = {}
              res.forEach(p => {
                  colors[p.PartyCode] = p.ColorCode
              })
          this.setState({
            parties:res,
            colors: colors
          })
      })
  }

  goToResOrStats = (url) => {
      let {connection, ...res} = this.state;
        this.props.history.push({
          pathname: url,
          state: res
      })
  }
  render() {
      const { election, Wards, Precincts, PrecinctAddresses, precinctAddressSelected, precinctAddressDefault, ancs, lastUpdate,
            electionDate, precinctCount, currentResult, year, appendPartyCodeToCandidateName,
            resultType, totalPrecincts, wardSelected, precinctSelected, ancSelected,
            versions, currentVersion, parties, curParty, electionCode, filter, resultsId, isAuth,
            curOffice, officeList, colors, CsvLink,ExcelLink,PdfLink, XmlLink, isLive, isWardPrecinctAvailable} = this.state
    //console.log(Precincts);
    return (
        <div>
        {isAuth && 
          <div style={{backgroundColor:'#e8f4f66e'}}>
            <div style={{background:`#0187d1 url(${bluebg}) no-repeat`, height:'219px', margin:'0 auto',width:'100%',backgroundSize:'cover'}}></div>
            <LiveMessage message={this.state.a11yMessage} aria-live="polite" clearOnUnmount="true"/>
            <ScrollToTop />
            <div className='container containTop'>
              <div className='content'>
                <div className="row erheader" style={{color:'white'}}>
                     {election &&<ERHeader lastUpdate={lastUpdate}
                                          precinctCount={precinctCount}
                                          totalPrecincts={totalPrecincts}
                                          election={election}
                                          resultType={resultType}
                                          isLive={isLive}
                                          electionDate={electionDate} />
                    }
                </div>
                
                <div className="row" >
                  <div className='col'>
                                <FilterOptions Wards={Wards}
                                    Precincts={Precincts}
                                    PrecinctAddresses={PrecinctAddresses}
                                    precinctAddressSelected={precinctAddressSelected}
                                    precinctAddressDefault={precinctAddressDefault}
                                    ancs={ancs}
                                    getResultsByWard={this.getResultsByWard}
                                    getResultsByCity={this.getResultsByCity}
                                    getResultsByPrecinct={this.getResultsByPrecinct}
                                    getResultsByANC={this.getResultsByANC}
                                    electionCode={electionCode}
                                    electionDate={electionDate}
                                    filter={filter}
                                    wardSelected={wardSelected}
                                    precinctSelected={precinctSelected}
                                    ancSelected={ancSelected}
                                    getResultsByWardNum={this.getResultsByWardNum}
                                    getResultsByPrecinctNum={this.getResultsByPrecinctNum}
                                    getResultsByANCNum={this.getResultsByANCNum}
                                    resultsId={resultsId}
                                    isStatsPage={false}
                                    isPublic={true}
                                    CsvLink={CsvLink}
                                    ExcelLink={ExcelLink}
                                    PdfLink={PdfLink}
                                    XmlLink={XmlLink}
                                    parties={parties} 
                                    curParty={curParty} 
                                    clearPartyFilter={this.clearPartyFilter}
                                    getPartyResults={this.getPartyResults}
                                    goToResOrStats={this.goToResOrStats}
                                    isWardPrecinctAvailable={isWardPrecinctAvailable}
                                    />
                  </div>
                </div>
                <div className='row content'  style={{ padding:'5px'}}>
                    {/*<BackLink 
                       backLink={<GenerateBackLink str={'Back to Election Results'} url={'/'} />}
                       domNode={'outerHeader'}
                        />*/}
                     <BackLink 
                        //backLink={<GenerateBackLink str={'Go to Main Website'} icon={<FaHome style={{marginTop:'15px'}} />} url={'https://dcboe.org/Request-Your-Ballot-by-Mail'} />}
                        backLink={<GenerateBackLink str={'Go to Main Website'} icon={<FaHome style={{ marginTop: '15px' }} />} url={'https://dcboe.org'} />}
                        domNode={'outerHeader'}
                    />
                    <BackLink 
                        domNode={'maincontainer'}
                        backLink={<a href={window.location.href+"#main-content"} className="link-skip" id="link-skip">Skip To Content</a>}
                    />
                    <OfficeResultList appendPartyCodeToCandidateName={appendPartyCodeToCandidateName} colors={colors} electionCode={electionCode} leftPart={this.state.leftPart}
                       rightPart={this.state.rightPart} topOfficeResult={this.state.topResult} />
                </div>
              </div>
            </div>
            </div>
         }
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PublicElectionResult.js